// swiper実行
// --- 最新のswiper v11ではループ時の不具合があるため、あえてv8を使用
document.addEventListener('DOMContentLoaded', function () {

  // --- 投稿スライダー -----
  if (document.querySelector('.js-article-slider')) {
    const swiper = new Swiper(".js-article-slider", {
      speed: 500,
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      slidesPerView: 1.2,
      spaceBetween: 15,
      centeredSlides: true,
      // ブレークポイント（画面幅による設定）
      breakpoints: {
        569: {
          slidesPerView: 2,
          spaceBetween: 20
        },
        769: {
          slidesPerView: 3.4,
          spaceBetween: 30
        }
      },
      pagination: {
        el: ".swiper-pagination",
        type: 'bullets',   // ドットナビゲーション
        clickable: true,
      },
      navigation: {	// 前後ナビゲーション
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }

  // --- 採用情報のENVIRONMENT -----
  if (document.querySelector('.js-env-slider')) {
    const swiper = new Swiper(".js-env-slider", {
      speed: 15000, // スライド変化時間
      loop: true,
      loopAdditionalSlides: 3,
      slidesPerView: 1.8,
      spaceBetween: 10,
      // centeredSlides: true,
      allowTouchMove: false, // スワイプ無効
      autoplay: {
        delay: 0, //　スライダー表示時間
        disableOnInteraction: false,
      },
      breakpoints: {
        // 421: {
        // slidesPerView: 2.5,
        // },
        569: {
          slidesPerView: 2.5,
          spaceBetween: 15,
        },
        769: {
          direction: 'vertical',
          slidesPerView: 1.8,
          spaceBetween: 30,
          autoplay: {
            reverseDirection: true,
          },
        },
      }
    });
  }

  // --- ギャラリースライダー（Reacruit > Environment > Office） -----
  if (document.querySelector('.js-gallery-slider')) {
    const swiper = new Swiper(".js-gallery-slider", {
      speed: 500,
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      slidesPerView: 1.7,
      spaceBetween: 20,
      centeredSlides: true,
      // ブレークポイント（画面幅による設定）
      breakpoints: {
        569: {
          slidesPerView: 2,
          spaceBetween: 30,
          centeredSlides: true,
        },
        769: {
          slidesPerView: 3.2,
          spaceBetween: 50,
          centeredSlides: false,
          slidesOffsetBefore: Math.floor((window.innerWidth - 50 * 3) / 3.2 * 0.43 * -1),
        }
      },
      pagination: {
        el: ".swiper-pagination",
        type: 'bullets',   // ドットナビゲーション
        clickable: true,
      },
      navigation: {	// 前後ナビゲーション
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }

  // --- ギャラリースライダー（Reacruit > Environment > Staff Interview） -----
  if (document.querySelector('.js-interview-slider')) {
    const swiper = new Swiper(".js-interview-slider", {
      speed: 500,
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      slidesPerView: 1.3,
      spaceBetween: 20,
      centeredSlides: true,
      // ブレークポイント（画面幅による設定）
      breakpoints: {
        569: {
          slidesPerView: 1.8,
          spaceBetween: 30,
          centeredSlides: true,
        },
        769: {
          slidesPerView: 3.2,
          spaceBetween: 50,
          centeredSlides: false,
          slidesOffsetBefore: Math.floor((window.innerWidth - 50 * 3) / 3.2 * 0.43 * -1),
        }
      },
      pagination: {
        el: ".swiper-pagination",
        type: 'bullets',   // ドットナビゲーション
        clickable: true,
      }
    });
  }




  // // swiper 自動再生
  // const swiper = new Swiper(".js-swiper .swiper", {
  //   loop: true,
  //   speed: 5000,
  //   autoplay: {
  //     delay: 0,
  //     disableOnInteraction: false,
  //   },
  //   slidesPerView: 1.5,
  //   spaceBetween: 10,

  //   // ブレークポイント（画面幅による設定）
  //   breakpoints: {
  //     // 画面幅が 768px 以上の場合（window width >= 768px）
  //     768: {
  //       slidesPerView: 2.5,
  //       spaceBetween: 20
  //     },
  //     // 画面幅が 1024px 以上の場合（window width >= 1024px）
  //     1024: {
  //       slidesPerView: 3.5,
  //       spaceBetween: 30
  //     }
  //   },
  // });


  // // swiper サムネイルと連動するスライダー
  // // サムネイル
  // const swiper_thumb = new Swiper('.js-swiper__thumb', {
  //   slidesPerView: 4,
  //   spaceBetween: 30,
  //   freeMode: true,
  //   slideToClickedSlide: true,
  //   watchSlidesVisibility: true,
  //   watchSlidesProgress: true,
  // })

  // // メインスライダー
  // const swiper_main = new Swiper('.js-swiper__main', {
  //   speed: 1000,
  //   autoplay: {
  //     delay: 3000,
  //     disableOnInteraction: false,
  //   },
  //   slidesPerView: 1,
  //   loop: true,
  //   loopedSlides: 6,
  //   centeredSlides: true,
  //   disableOnInteraction: true,
  //   navigation: {
  //     nextEl: '.js-swiper .swiper-button-next',
  //     prevEl: '.js-swiper .swiper-button-prev',
  //   },
  //   thumbs: {
  //     swiper: swiper_thumb,
  //   },
  // })

})